import React, { useCallback, useContext, useMemo, useState } from 'react'
import styled from 'styled-components'
import copy from 'copy-text-to-clipboard'
import { Popover, FlashMessage } from 'fbk-components'
import { Sharing } from 'components'
import * as Icons from 'assets/svg'
import { useRouter } from 'next/router'
import { SiteContentContext } from 'contexts'

const Wrapper = styled.aside`
  position: sticky;
  top: 120px;
  z-index: 6;
  display: none;
  width: 60px;
  height: 60px;
  margin-left: 1100px;

  > div {
    margin-top: -8px;
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    transition: 0.2s ease;

    :hover {
      background: ${({ theme }) => theme.colors.primaryHover};
    }
  }

  @media (min-width: 1200px) {
    display: flex;
    justify-content: flex-end;
  }
`

const PopoverContent = styled.div`
  position: relative;
  min-width: 540px;
  padding: 40px;
  background: #fff;
  box-shadow: 0 1px 40px rgba(0, 0, 0, 0.15);

  .title {
    margin-bottom: 32px;
  }

  .close {
    position: absolute;
    top: 18px;
    right: 18px;
    color: ${({ theme }) => theme.colors.grey};
    transition: 0.2s ease;

    :hover {
      color: #000;
    }
  }

  .sharing-content {
    display: flex;
  }

  li {
    margin-right: 20px;
  }

  .sharing-item {
    width: 60px;
    height: 60px;
  }

  .copy {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ebeefa;

    :hover {
      filter: brightness(102%);
    }
  }
`

const StyledFlashMessage = styled(FlashMessage)`
  top: 80px;
  width: 204px;
  height: 60px;
  font-size: 20px;
  letter-spacing: 0.05em;
  background: rgba(0, 0, 0, 0.8);
`

const SharingAside = () => {
  const [popoverIsOpen, setPopover] = useState(false)
  const [flasMessageIsOpen, setFlashMessage] = useState(false)

  const { host } = useContext(SiteContentContext)

  const { asPath } = useRouter()

  const handleCopy = useCallback(
    e => {
      e.preventDefault()
      copy(`${host}${asPath}`)
      setFlashMessage(true)
    },
    [asPath, host],
  )

  const popoverContent = useMemo(
    () => (
      <PopoverContent>
        <h3 className="title">Поделиться в соцсетях</h3>
        <button onClick={() => setPopover(false)} className="close">
          <Icons.Close />
        </button>
        <div className="sharing-content">
          <Sharing
            socials={[
              {
                type: 'telegram',
                IconComponent: Icons.TelegramWhite,
                backgroundColor: '#3AA7DE',
              },
              {
                type: 'twitter',
                IconComponent: Icons.TwitterWhite,
                backgroundColor: '#29A3EF',
              },
              {
                type: 'vk',
                IconComponent: Icons.VkWhite,
                backgroundColor: '#46678D',
              },
              {
                type: 'facebook',
                IconComponent: Icons.FacebookWhite,
                backgroundColor: '#3D5C96',
              },
              {
                type: 'ok',
                IconComponent: Icons.OkWhite,
                backgroundColor: '#FF6900',
              },
            ]}
          />
          <a className="sharing-item copy" href="." onClick={handleCopy}>
            <Icons.Copy />
          </a>
        </div>
      </PopoverContent>
    ),
    [handleCopy],
  )

  return (
    <>
      <Wrapper>
        <Popover
          positionX="right"
          positionY="top"
          isOpen={popoverIsOpen}
          content={popoverContent}
          onRequestClose={() => setPopover(false)}
        >
          <button className="btn" onClick={() => setPopover(true)}>
            <Icons.Sharing />
          </button>
        </Popover>
      </Wrapper>
      <StyledFlashMessage
        className="g-big-text"
        isOpen={flasMessageIsOpen}
        onClose={() => {
          setFlashMessage(false)
        }}
      >
        Скопировано
      </StyledFlashMessage>
    </>
  )
}

export default SharingAside
